import React, { useContext, useEffect, useState } from "react";
import { RoundUserContext, ValueContext } from "../../../context/createContext";
import { TotalBetsContainer } from "./TotalBetsStyle";

const TotalBets = ({ jackpot }: any) => {
  const {
    roundupdate: { state },
  } = useContext(ValueContext);

  const roundUserUpdates = useContext(RoundUserContext);
  const [numberOfBets, setNumberOfBets] = useState<any[]>([]);

  useEffect(() => {
    const newRound = roundUserUpdates.filter(
      (round) => round.index !== "" && round.cashout === 0
    );

    roundUserUpdates.forEach((bet) => {
      if (bet.cashout > 0) {
        newRound.pop();
      }
    });
    setNumberOfBets(newRound);
  }, [roundUserUpdates]);

  useEffect(() => {
    if (state === 3) {
      setNumberOfBets([]);
    }
  }, [state]);
  return numberOfBets.length !== 0 ? (
    <TotalBetsContainer jackpot={jackpot}>
      {numberOfBets.length !== 1 ? numberOfBets.length + " bets" : "1 bet"}
    </TotalBetsContainer>
  ) : (
    <></>
  );
};

export default TotalBets;
